if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.addEventListener('click', (event) => {
          if (!event.target.closest('[data-wallify-direct-checkout]')) return;
          if (this.validatePersonalization(this.form)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const sourceFormId = this.dataset.productFormId;
        const sourceForm = sourceFormId ? document.getElementById(sourceFormId) : this.form;
        if (!sourceForm) return;

        if (!this.validatePersonalization(sourceForm)) return;
        if (sourceForm !== this.form && !this.form.reportValidity()) return;

        this.handleErrorMessage();
        this.querySelector('[data-wallify-network-error]')?.remove();
        let itemAdded = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(sourceForm);
        if (sourceForm !== this.form) {
          formData.set('id', new FormData(this.form).get('id'));
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            itemAdded = true;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-modal');
            
            if (quickViewModal) {
              quickViewModal.classList.remove('active');
              document.body.classList.remove('quickview-open');
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            const message = document.createElement('p');
            message.dataset.wallifyNetworkError = '';
            message.className = 'product-form__error-message form__message';
            message.setAttribute('role', 'alert');
            message.textContent = window.cartStrings.addError || window.cartStrings.error;
            this.appendChild(message);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (itemAdded && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      validatePersonalization(form) {
        for (const field of form.elements) {
          if (!field.name?.startsWith('properties[') || !field.required) continue;
          if (field.type === 'text' || field.tagName === 'TEXTAREA') {
            field.value = field.value.trim();
            field.setCustomValidity(field.value ? '' : (field.dataset.wallifyRequiredMessage || ''));
            if (!field.validity.valid) {
              field.addEventListener('input', () => field.setCustomValidity(''), { once: true });
            }
          }
        }
        return form.reportValidity();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

